import { Component, ElementRef } from '@angular/core';
import { MeasureVO } from '@wizeoo/akm-compute-lib';
import { IWizItemRenderer, WizBaseCollector, WizEventManager } from '@wizeoo/akm-component-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'vision-measure-list-renderer',
  template: `
    <wiz-hgroup [wizDisabled]="owner.wizDisabled" width="100%" height="100%" verticalAlign="center" style="padding-left:5px; padding-right:5px">
      <wiz-icon #iconRemove  [wizTooltip]="'$.vision.measure.remove.$'" (click)="doRemove($event)">delete</wiz-icon>
      <wiz-label [wizLabel]="data.trsFullLabel" width="100%"></wiz-label>
    </wiz-hgroup>
  `,
})
export class VisionMeasureListRenderer implements IWizItemRenderer<null, MeasureVO> {
  constructor(public elementRef: ElementRef) {}

  data: MeasureVO;
  owner: WizBaseCollector;

  public doRemove(e: Event): void {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.REMOVE_MEASURE, this.data));
  }
}
